const PREFIXED_RE = /^\/(?:branch|demos|blog)\/([a-z0-9-]+)(?:\/|$)/;
const SINGLE_SEGMENT_RE = /^\/([a-z0-9-]+)\/?$/;

export function resolveDynamicSlug(pathname: string): string | undefined {
  return (
    pathname.match(PREFIXED_RE)?.[1] ??
    pathname.match(SINGLE_SEGMENT_RE)?.[1] ??
    undefined
  );
}
